// extracted by mini-css-extract-plugin
export default {"Main":"Timeline_Main__mt48C","Info":"Timeline_Info__eAAul","Phone":"Timeline_Phone__npUK+"};